<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Edit Item</h2>
        <!-- Image Preview -->
      <div v-if="localItem.filename" class="mt-4">
        <img :src="localItem.filename" alt="Item Image" class="m2 w-full h-auto rounded-lg"/>
      </div>
      <div v-else class="mt-4 text-gray-500">
        <p>No image available for this item.</p>
      </div>
        <form @submit.prevent="submitItem">
        <input v-model="localItem.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Item Name" required />
        <input v-model="localItem.description" class="w-full p-2 border rounded-lg mb-4" placeholder="Item Description" required />
        <input v-model="localItem.unit" class="w-full p-2 border rounded-lg mb-4" placeholder="Eg. Kg, Liters, Pieces,..." required />
        <input v-model="localItem.quantity" type="number" class="w-full p-2 border rounded-lg mb-4" placeholder="Quantity" required />
        <input v-model="localItem.price" type="number" class="w-full p-2 border rounded-lg mb-4" placeholder="Price" min="0" required />

        <!-- Category Dropdown -->
        <select v-model="localItem.category" class="w-full p-2 border rounded-lg mb-4" required>
          <option disabled value="">Select a Category</option>
          <option v-for="category in categories" :key="category" :value="category">{{ category.name }}</option>
        </select>
        <!-- File Input for Image Upload -->
        <input type="file" @change="handleImageUpload" accept="image/*" class="w-full p-2 border rounded-lg mb-4" required />


          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Update Item</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
import { mapActions, mapState } from 'vuex';

  export default {
    props: {
      item: {
      },
    },
    data() {
      return {
        localItem: { ...this.item }, // Create a local copy of the staff prop
      };
    },
    async mounted(){
    await this.fetchCategories()
  },
  computed: {
    ...mapState('categories', {
      categories: state => state.categories,
    })
   },
    methods: {
      ...mapActions('items', {
        updateItem : 'updateItem'
    }),
    ...mapActions('categories',{
      fetchCategories : 'fetchCategories'
    }),
    handleImageUpload(event) {
      const file = event.target.files[0];
      this.localItem.image = file; // Store the selected file in the item object
      this.localItem.filename = URL.createObjectURL(file);
    },
      submitItem() {
        this.$emit('editItem', this.localItem);
        this.updateItem(this.localItem);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
  </script>
  